import { motion } from 'framer-motion'
import React from 'react'
import { Container } from 'react-bootstrap'
import Footer from '../components/Footer'
import PageWrapper from '../components/PageWrapper'
import PageSeo from '../components/seo/PageSeo'
import SideMenu from '../components/SideMenu'


export default function SpecialArrangements() {
    return (
      <motion.div 
      initial={{ y: -150, opacity: 0}}
      animate={{ y:0, opacity: 1}}
      exit={{ opacity: 0 }}>
        <PageSeo h1="Special Arrangements" />
        <SideMenu pageWrapId={'outer-page-wrapper'} outerContainerId={'inner-page-wrapper'} />
        <PageWrapper name={'Arrangements'} display={<h1 className="txt-big">Special Arrangements</h1>}>
          <span className="txt-cream txt-shadow">Custom group itineraries and one-off transport plans across Jamaica.</span>
        </PageWrapper>
        <Container className="text-cream mb-5" style={{ maxWidth: '70ch' }}>
          <p>
            From multi-stop tours between Montego Bay, Ocho Rios, and Negril to private group moves, Reggae Wheels
            can help shape a custom plan. Contact us via About Us with your dates and party size.
          </p>
        </Container>
        <Footer></Footer>
      </motion.div>
      )
}
